import { useAuth } from "@/context/AuthContext";

/** Central BDS branding. Uses the uploaded logo from Settings, with a clean text fallback. */
export const BdsLogo = ({ size = 40, showText = true, stacked = false, className = "" }) => {
  const { settings } = useAuth();
  const logo = settings?.shop?.logo;
  const name = settings?.shop?.name || "Bharat Digital Seva";

  return (
    <div
      data-testid="bds-logo"
      className={`flex min-w-0 ${stacked ? "flex-col items-start gap-2" : "items-center gap-3"} ${className}`}
    >
      {logo ? (
        <img
          src={logo}
          alt={name}
          style={{ height: size, width: "auto", maxWidth: size * 3.4, objectFit: "contain" }}
          className="shrink-0"
        />
      ) : (
        <span
          style={{ height: size, width: size }}
          className="flex shrink-0 items-center justify-center rounded-xl bg-indigo-600 font-outfit text-sm font-bold text-white"
        >
          BDS
        </span>
      )}
      {showText && (
        <span className="min-w-0">
          <span className="block truncate font-outfit text-base font-bold leading-none text-indigo-700">{name}</span>
          <span className="block text-[10px] uppercase tracking-[0.18em] text-slate-400">Retail Management</span>
        </span>
      )}
    </div>
  );
};

export default BdsLogo;
